<template>
  <div id="routerBody">
    <div class="scroll">
      <div class="body_head">
        <el-breadcrumb separator-icon="ArrowRight">
          <el-breadcrumb-item
            v-for="(item, index) in routerArr"
            :key="index"
            :to="item.path"
            >{{ item.name }}</el-breadcrumb-item
          >
        </el-breadcrumb>

        <el-button size="small" icon="Tools" v-show="false">设置</el-button>
      </div>

      <div :class="contianerFilter">
        <router-view v-slot="{ Component }">
          <transition name="switch" mode="out-in">
            <keep-alive exclude="photoInfo">
              <component :is="Component"></component>
            </keep-alive>
          </transition>
        </router-view>
      </div>
    </div>

    <el-drawer
      v-model="drawer"
      :modal="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="notitle"
      modal-class="el-drawer__wrapper"
      :size="$store.state.screenWidth > 1200 ? '100%' : '100%'"
      direction="rtl"
    >
      <template #header>
        <div>
          <h3 class="title">{{ componentTitle }}</h3>
        </div>
      </template>
      <div class="body">
        <keep-alive>
          <component
            :is="componentName"
            :data="componentData"
            :drawer="drawer"
            @closedrawer="closedrawer"
          ></component>
        </keep-alive>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import washingMachineList from "@/views/washingMachine/washingMachineList.vue";
import washingMachineSetting from "@/views/washingMachine/washingMachineSetting.vue";
import userInfo from "@/components/userInfo.vue";
export default {
  name: "routerBody",
  components: {
    washingMachineList,
    washingMachineSetting,
    userInfo,
  },
  data() {
    return {
      componentName: "washingMachineList",
      componentData: {},
      componentTitle: "",
      //面包屑数据
      routerArr: [],
      //抽屉打开状态
      drawer: false,
    };
  },
  provide() {
    return {
      opendrawer: this.opendrawer,
      closedrawer: this.closedrawer,
      quickData: () => this.quickData,
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path == "/") {
          return false;
        }
        this.drawer = false;
        let pathArr = to.path.slice(1).split("/");
        let routerPathArr = this.$dataConver.treeFilter(
          this.$router.options.routes
        );
        this.routerArr = pathArr.map((item) => {
          return routerPathArr.find((item2) => {
            return item == item2.pathName;
          });
        });
      },
      immediate: true,
    },
    componentName: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case "washingMachineList":
            this.componentTitle = "门店设备管理";
            break;
          case "washingMachineSetting":
            this.componentTitle = "门店配置";
            break;
          case "userInfo":
            this.componentTitle = "个人信息";
            break;
          default:
            break;
        }
      },
      immediate: true,
    },
  },
  computed: {
    contianerFilter() {
      let str = "contianer";
      switch (this.$route.name) {
        default:
          str = "contianer";
          break;
      }
      return str;
    },
  },
  methods: {
    //打开抽屉
    opendrawer(name, obj = null) {
      this.componentName = name;
      this.componentData = obj;
      this.drawer = true;
    },
    closedrawer(data) {
      // if (data) this.quickData = [...data];
      this.drawer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/routerBody.scss";
</style>